import type { LogoWallRow } from '~/components/dcb/landingpage/logo-wall.vue';

export const appIcons = [
  {
    src: '/content/content-images/dcb/stores/app-icons/fadd8b90d29e89d5e2a313600c90001e/icon-youtube.png',
    alt: 'YouTube',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/0c7c93524bb12d64f02c8174b16e10e1/icon-chatgpt.svg',
    alt: 'ChatGPT',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/982f398cb40fcc95a046eabdb4c06948/icon-endel.png',
    alt: 'Endel',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/5ae44c3002f3294ddb3b1e2dc90052d5/icon-audioteka.png',
    alt: 'Audioteka',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/0b35a2760fae5f8d0c9883275ced513d/icon-amazon.png',
    alt: 'Amazon',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/b09e0b38fd385c51f75b8e1d692e53bf/icon-booking.png',
    alt: 'Booking.com',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/3148d143fe070eb5f9b30fb9ae31fb2b/icon-brawl-stars.png',
    alt: 'Brawl Stars',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/8bc6158e0cb3376807edad07b60bc461/icon-candy-crush.png',
    alt: 'Candy Crush',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/5cc90181248b91f53fd8b941195d1fe2/icon-clash-of-clans.png',
    alt: 'Clash of Clans',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/352bb10f2777a2398b736e40392376bb/icon-coin-master.png',
    alt: 'Coin Master',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/cbf39981f5ee11dcb74e04f3e611d48f/icon-dazn.png',
    alt: 'DAZN',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/77810b22b06fd81dadbbcb4dc4706fd8/icon-disney-plus.png',
    alt: 'Disney+',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/b1480cbfa8c6a9b5afeea85ec1b7a615/icon-duolingo.png',
    alt: 'Duolingo',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/2a0b41dc1840acce9def7429950792dd/icon-fortnite.png',
    alt: 'Fortnite',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/0e464823ceb87eec0afd46206fa5a1d2/icon-genshin-impact.png',
    alt: 'Genshin Impact',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/7cfa542d1031682c48e6d3bc626f8587/icon-instagram.png',
    alt: 'Instagram',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/9ba67b15ad2ea69e0f7f4c1dc07aaf17/icon-monopoly-go.png',
    alt: 'Monopoly GO!',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/1cf8e21fd89827ab65500bd115fb5db4/icon-netflix.png',
    alt: 'Netflix',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/414d860caae87bbdbb4aef17dd0e27fc/icon-paypal.png',
    alt: 'PayPal',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/aff704c1e47fbda1f05f07b34f544649/icon-pinterest.png',
    alt: 'Pinterest',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/ce67cfe3dfee9ed0e61e321b54bf3b43/icon-pokemon-go.png',
    alt: 'Pokémon GO',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/5ab8fe71b625a4d01dce6b640398959b/icon-prime-video.png',
    alt: 'Prime Video',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/eda5b692947f13fab37c0dd52e14d029/icon-roblox.png',
    alt: 'Roblox',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/16aa76b8bb1dd02a3f31d599f981e143/icon-snapchat.png',
    alt: 'Snapchat',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/8c6fb628dc4ccfeb22b0117d4cde8d2e/icon-spotify.png',
    alt: 'Spotify',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/e6f713c6c7ec74e2d426adf12456d996/icon-subway-surfers.png',
    alt: 'Subway Surfers',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/04be4b5b0423c9506d6e7c57be732d90/icon-telegram.png',
    alt: 'Telegram',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/c6c421463b98190d0f746556ff2133aa/icon-threads.png',
    alt: 'Threads',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/58f096d456b3bdafad768221d9711215/icon-tiktok.png',
    alt: 'TikTok',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/68ce002fe7cfe9dcf701691e19a83b20/icon-twitch.png',
    alt: 'Twitch',
  },
  {
    src: '/content/content-images/dcb/stores/app-icons/a667881fab96210c262b3047c9c0f985/icon-whatsapp.png',
    alt: 'WhatsApp',
  },
];

export const findAppIcon = (alt: string) => appIcons.find((icon) => icon.alt === alt);

export const logoWall4Rows: LogoWallRow[] = [
  {
    logos: [
      'Fortnite',
      'Netflix',
      'TikTok',
      'Clash of Clans',
      'Disney+',
      'Spotify',
      'Instagram',
    ].map((alt) => findAppIcon(alt) ?? { alt }),
  },
  {
    reverse: true,
    logos: [
      'Candy Crush',
      'YouTube',
      'Brawl Stars',
      'Pokémon GO',
      'DAZN',
      'WhatsApp',
      'Roblox',
    ].map((alt) => findAppIcon(alt) ?? { alt }),
  },
  {
    logos: ['Prime Video', 'Snapchat', 'Twitch', 'Amazon', 'PayPal', 'Telegram', 'Duolingo'].map(
      (alt) => findAppIcon(alt) ?? { alt }
    ),
  },
  {
    reverse: true,
    logos: [
      'Subway Surfers',
      'Genshin Impact',
      'Coin Master',
      'Monopoly GO!',
      'Threads',
      'Pinterest',
      'Booking.com',
    ].map((alt) => findAppIcon(alt) ?? { alt }),
  },
];

export const logoWall3Rows: LogoWallRow[] = [
  {
    logos: ['Clash of Clans', 'Netflix', 'TikTok', 'Disney+', 'Fortnite', 'Spotify'].map(
      (alt) => findAppIcon(alt) ?? { alt }
    ),
  },
  {
    reverse: true,
    logos: ['Instagram', 'Pokémon GO', 'DAZN', 'Candy Crush', 'YouTube', 'Brawl Stars'].map(
      (alt) => findAppIcon(alt) ?? { alt }
    ),
  },
  {
    logos: ['WhatsApp', 'Duolingo', 'Prime Video', 'Fortnite', 'Spotify', 'Roblox'].map(
      (alt) => findAppIcon(alt) ?? { alt }
    ),
  },
];
